<script>
import {mapActions} from "vuex";

export default {
  name: "InstructionHistoryDialog",
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      instructionHistories: [],
      selectedPanel: null,
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      Object.assign(this.$data.instructionHistories, this.$options.data().instructionHistories);
      this.selectedPanel = null;
      if (newValue) {
        this.setVariable()
      }
    },
  },
  created() {},
  methods: {
    ...mapActions('DriverAllocateInstructionHistory', {
      fetchHistories: 'index',
    }),
    /**
     * 閉じるボタン クリックイベント
     * 呼び出し元のメソッドを発火
     */
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    /**
     * 登録するボタン クリックイベント
     * データ登録を行い、呼び出し元にデータを渡す
     */
    reflectionButtonClickEvent (item) {
      this.$emit("reflectionEvent", item)
    },
    /**
     * 初期データセット
     */
    setVariable () {
      this.fetchHistories().then((response) => {
        this.instructionHistories = response.instruction_histories;
      })
    }
  }
}
</script>

<template>
  <v-dialog
    :value="enableDialog"
    persistent
    width="800"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">入力履歴</span>
      </v-card-title>
      <v-divider />
      <v-card-text
        class="pt-4"
        style="max-height: 500px;height: 400px;overflow-y: scroll"
      >
        <v-expansion-panels
          v-model="selectedPanel"
          class="instructionHistory">
          <v-expansion-panel
            v-for="history in instructionHistories"
            :key="history.id"
          >
            <v-expansion-panel-header color="grey lighten-4">
              {{ history.updated_at | unix_datetime_format }}<br />
              {{ history.title }}
            </v-expansion-panel-header>
            <v-divider />
            <v-expansion-panel-content>
              <v-card >
                <v-card-text>
                  <v-textarea
                    :value="history.content"
                    :readonly="true"
                    :filled="true"
                    :dense="true"
                    :no-resize="true"
                    :outlined="true"
                    :persistent-hint="true"
                    :persistent-placeholder="true"
                    :rows="4"
                    :row-height="30"
                    hide-details="auto"
                  >
                  </v-textarea>
                </v-card-text>
                <v-divider />
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="reflectionButtonClickEvent(history)"
                  >
                    反映
                  </v-btn>
                </v-card-actions>
              </v-card>

            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn @click="closeButtonClickEvent">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style lang="scss">
.instructionHistory .v-expansion-panel-content__wrap {
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-bottom: 0 !important;
}
</style>
